/* eslint-disable no-invalid-this */
import React, { Suspense, useCallback, useMemo } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import _ from 'lodash';
import EADCubicle from './components/EADCubicle';
import EADNurseStation from './components/EADNurseStation';
import EADMemo from './components/EADMemo';

const useStyles = makeStyles(() => ({
  floorplanContainer: ({ floorDimension }) => ({
    display: 'flex',
    flexDirection: 'column',
    width: floorDimension.width > 0 ? floorDimension.width + floorDimension.left : '100%',
    height: floorDimension.height > 0 ? floorDimension.height + floorDimension.top : '100%',
    position: 'relative',
    overflow: 'visible',
    touchAction: 'none',
  }),
}));

const CUBICLE_TYPE = {
  NURSE_STATION: 'Nurse Station/Misc.',
  MEMO: 'Memo',
};

export default function EADViewFloorPlan({
  toolStatus,
  cubicleList,
  selectedBed,
  handleSelectBed,
  handleDeleteBedPatient,
  handleOpenPatientDetail,
  handleUpdateCubicle,
  viewType = '',
  showDetails = true,
  patientInfoViewType = '',
}) {
  const floorDimension = useMemo(() => {
    let width = 0;
    let height = 0;
    let top = 0;
    let left = 0;

    _.forEach(cubicleList, (item) => {
      if (Number(item.x) + Number(item.width) > Number(width)) {
        width = Number(item.x) + Number(item.width);
      }

      if (Number(item.y) + Number(item.height) > Number(height)) {
        height = Number(item.y) + Number(item.height);
      }

      if (Number(item.y) < 0 && Number(item.y) < Number(top)) {
        top = -Number(item.y);
      }

      if (Number(item.x) < 0 && Number(item.x) < Number(left)) {
        left = -Number(item.x);
      }
    });

    return {
      width,
      height,
      top,
      left,
    };
  }, [cubicleList]);
  const classes = useStyles({ toolStatus, floorDimension });

  const getCubicleStyle = useCallback((item) => {
    const cubicleWidth = item?.width;
    const cubicleLeft = item.x;

    return {
      position: 'absolute',
      top: `${item.y + floorDimension.top}px`,
      left: `${cubicleLeft + floorDimension.left}px`,
      width: `${cubicleWidth}px`,
      height: `${item.height}px`,
    };
  }, []);
  const renderMemo = (cubicleItem) => (
    <EADMemo cubicleData={cubicleItem.data} id={cubicleItem.id} handleUpdateCubicle={handleUpdateCubicle} />
  );
  const renderCubicle = (cubicleItem) => (
    <EADCubicle
      cubicleData={cubicleItem.data}
      id={cubicleItem.id}
      handleUpdateCubicle={handleUpdateCubicle}
      selectedBed={selectedBed}
      handleSelectBed={handleSelectBed}
      handleDeleteBedPatient={handleDeleteBedPatient}
      handleOpenPatientDetail={handleOpenPatientDetail}
      viewType={viewType}
      showDetails={showDetails}
      patientInfoViewType={patientInfoViewType}
    />
  );
  const renderNurseStation = (cubicleItem) => (
    <EADNurseStation cubicleData={cubicleItem.data} id={cubicleItem.id} handleUpdateCubicle={handleUpdateCubicle} />
  );

  const renderContent = (cubicleItem) => {
    if (cubicleItem?.data?.type === CUBICLE_TYPE?.NURSE_STATION) {
      return renderNurseStation(cubicleItem);
    } else if (cubicleItem?.data?.type === CUBICLE_TYPE?.MEMO) {
      return renderMemo(cubicleItem);
    } else {
      return renderCubicle(cubicleItem);
    }
  };

  return (
    <Box className={classes.floorplanContainer}>
      {cubicleList.map((item) => (
        <Suspense fallback={<div />} key={item.id}>
          <Box style={getCubicleStyle(item)}>{renderContent(item)}</Box>
        </Suspense>
      ))}
    </Box>
  );
}
